import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { deleteOccupationArea } from "../../helper/API/occupation";
import { toast } from "react-toastify";
import { deleteNoteType } from "../../helper/API/note";
import { CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import * as noteAction from "../../redux/noteList/action";

const DeleteModal = ({
  open,
  handleClose,
  data,
  setRefresh,
  refresh,
  noteListData,
}) => {
  const [loading, setLoading] = React.useState(false);

  const handleSubmit = () => {
    setLoading(true);
    const submitData = {
      id: data.id,
    };
    deleteNoteType(submitData).then((res) => {
      if (res.success) {
        handleClose();
        // setRefresh(refresh + 1);
        noteListData();
        toast.success(res.message);
        setLoading(false);
      } else {
        toast.error(res.message);
        setLoading(false);
      }
    });
  };
  return (
    <div>
      <Dialog fullWidth maxWidth={"sm"} open={open} onClose={handleClose}>
        <DialogTitle>Excluir nota</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza de que deseja excluir o tipo de nota?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="inherit">
            Não
          </Button>
          <Button
            onClick={handleSubmit}
            variant="outlined"
            color="error"
            sx={{ position: "relative" }}
            disabled={loading}
          >
            Sim
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
const mapDispatchToProp = (dispatch) => {
  return {
    noteListData: () => dispatch(noteAction.noteList()),
  };
};
export default connect(null, mapDispatchToProp)(DeleteModal);
